import React from 'react';
import { FaRegClock } from 'react-icons/fa';
import { CiCalendar } from "react-icons/ci";
import { CiMapPin } from "react-icons/ci";
import foto1 from '../../images/palhacaria.jpg'

const DetailItem = ({ icon: Icon, text }) => (
  <div className="flex items-center space-x-3 mb-4">
    <Icon className="text-primary w-5 h-5 flex-shrink-0" />
    <p className="text-gray-700 text-base">{text}</p>
  </div>
);

function Card({ src }) {
  return (
    <div className="w-full h-[400px] md:h-[500px] rounded-xl overflow-hidden">
      <iframe
        title="mapa"
        src={src}
        className="w-full h-full border-0"
        allowFullScreen
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
      ></iframe>
    </div>
  );
}


const palhacaria = () => {

  return (
    <div className="min-h-screen lg:pt-20 bg-gray-50 font-rubik">
      
      {/* Seção 1: Cabeçalho com Título, Descrição e Imagem */}
      <header className="bg-second pt-10 pb-16 px-4 md:px-8">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row lg:space-x-12 items-center">
          
          {/* Texto de Introdução */}
          <div className="lg:w-1/2 text-white mb-8 lg:mb-0">
            <h1 className="text-4xl md:text-5xl font-extrabold mb-4 leading-tight">
              A arte da <br />Palhaçaria Solidária
            </h1>
            <p className="text-lg md:text-xl leading-relaxed">
              Estamos procurando voluntários para se juntar à nossa equipe na área lúdica, para ajudar a criar momentos de alegria e descontração para aqueles que estão passando por um momento difícil.
            </p>
          </div>
          
          {/* Imagem do Cabeçalho */}
          <div className="lg:w-1/2 rounded-xl overflow-hidden shadow-2xl">
            <img
              src={foto1}
              alt="Palhaços médicos sorrindo e posando"
              className="w-full h-auto object-cover"
              onError={(e) => { e.target.onerror = null; e.target.src='https://placehold.co/600x400/003087/ffffff?text=Imagem+N%C3%A3o+Carregada' }}
            />
          </div>
        </div>
      </header>

      {/* Ícone de Chapéu de Palhaço (Joker Hat) decorativo */}
      <div className="w-full h-24 bg-gray-50 relative -mt-12 overflow-hidden flex justify-center">
        {/* SVG de um chapéu de bobo da corte/palhaço estilizado */}
        <svg
          className="absolute top-0 w-24 h-24 text-fourth -translate-y-1/2"
          viewBox="0 0 100 100"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          {/* Base do chapéu */}
          <path d="M50 85L30 50L70 50L50 85Z" fill="#0072CE" /> {/* primary */}
          {/* Ponta 1 com guizo */}
          <path d="M30 50L20 20L40 40L30 50Z" fill="#00B388" /> {/* third */}
          <circle cx="20" cy="20" r="5" fill="#003087" /> {/* second */}
          {/* Ponta 2 com guizo */}
          <path d="M70 50L80 20L60 40L70 50Z" fill="#00B388" /> {/* third */}
          <circle cx="80" cy="20" r="5" fill="#003087" /> {/* second */}
          {/* Base Central (Colarinho) */}
          <path d="M50 50C40 50 40 40 50 40C60 40 60 50 50 50Z" fill="#0072CE" /> {/* primary */}
        </svg>
      </div>


      {/* Seção de Detalhes da Vaga: Horários e Endereço */}
      <section className="py-12 px-4 md:px-8 max-w-7xl mx-auto bg-white shadow-lg rounded-xl mt-4 relative z-10">
        
        <h3 className="text-2xl font-bold text-second mb-6">Horários</h3>
        <p className="text-gray-600 mb-6">
          Leia abaixo as descrições de horários para atuar nessa vaga.
        </p>

        <div className="mb-8">
          <DetailItem icon={CiCalendar} text="À combinar" />
          <DetailItem icon={FaRegClock } text="2 horas semanais" />
        </div>

        <h3 className="text-2xl font-bold text-second mb-6">Endereço da vaga</h3>
        <DetailItem
          icon={CiMapPin}
          text="Santo André, SP, Brasil"
        />

        <div className="mt-8 rounded-xl overflow-hidden shadow-md border border-gray-200">
            <Card src='https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3749.9191244811336!2d-43.95160522477182!3d-19.96990318142752!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xa697f13759c0b3%3A0x70615013e45e847e!2sR.%20Denver%2C%20190%20-%20Santa%20L%C3%BAcia%2C%20Belo%20Horizonte%20-%20MG%2C%2030360-630!5e0!3m2!1spt-BR!2sbr!4v1746140390921!5m2!1spt-BR!2sbr' />
        </div>
        
      </section>

      {/* Seção Final: Chamada para Ação */}
      <section className="py-16 px-4 md:px-8 max-w-7xl mx-auto">
        <div className="bg-primary/5 p-8 rounded-xl border-t-4 border-primary text-gray-700 leading-relaxed">
          <p className="mb-4 text-lg font-medium">
            Se você se interessa em se tornar um voluntário na área lúdica para pacientes paliativos, por favor, entre em contato conosco e vamos conversar mais sobre essa oportunidade única de fazer a diferença na vida de quem precisa.
          </p>
        </div>
      </section>

      {/* Footer simples */}
      <footer className="bg-second py-4 text-center text-white text-sm">
        <p>Associação Kerailty Brasil | A arte da Palhaçaria Solidária © 2025</p>
      </footer>
    </div>
  );
};

export default palhacaria;